import React, { useEffect } from "react";
import DrawerService from "Services/http/endpoints/design/DrawerService";
import { read } from "Helpers/LocalStorage";
import { useSetState } from "Helpers/Hooks";
import Grid from "@material-ui/core/Grid";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Translator from "Languages/Utility/Translator";
import StatusHandler from "Helpers/StatusHandler";
import {useSelector} from "react-redux";

function FrameRightClick({ data, onChangeData }) {
  const { selectedUser } = useSelector((state) => ({
    selectedUser: state.project.selectedUser,
  }));
  const [controls, setControls] = useSetState({
    frame: {
      type: "select",
      selectItems: [],
      value: "",
    },
  });

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
  };

  useEffect(() => {
    (async () => {
      try {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdProduct: data.Id_frame,
          All: true,
          UserSelect: 0,
          KeyRequestUser: selectedUser?.Key
        };
        const response = await DrawerService.getListProfileRight(params);
        let err = StatusHandler(response);
        if (!err.isFail) {
          const projectList = response.data.Value;
          const items = projectList.map((m) => {
            return {
              ...m,
              value: m.Id,
              label: m.Name,
            };
          });
          const selectedItem = items.find((item) => item.Id === data.Id_frame)
          setControls({frame: {value: selectedItem}});
          setControls({ frame: { selectItems: items } });
        }
      } catch (err) {
      console.error('[catch error]', err)
    }
    })();
  }, []);

  useEffect(() =>{
    onChangeData(controls);
  },[controls]);

  return (
    <Grid item xs={12}>
      <MuiAutoComplete
        autoSelect= {true}
        options={controls.frame.selectItems}
        label={<Translator id={"frame"} />}
        value={controls.frame.value}
        id={"frame"}
        onChange={autoCompleteHandler}
      />
    </Grid>
  );
}

export default FrameRightClick;
